import { defineStore } from "pinia";
import { applicationSetup_actions, applicationSetup_getters, applicationSetup_state } from "./applicationSetup";
import { settings_actions, settings_getters, settings_state } from "./settings";
import { quickshare_actions, quickshare_getters, quickshare_state } from "./quickshare";

export const useSettingsStore = defineStore("settings", {
  state: () => Object.assign({}, settings_state, quickshare_state, applicationSetup_state),
  actions: Object.assign({}, settings_actions, quickshare_actions, applicationSetup_actions),
  getters: Object.assign({}, settings_getters, quickshare_getters, applicationSetup_getters)
});
